module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "noteslistPlans",
    staticClass: "noteslist-plans-modal",
    attrs: {
      "md-theme": "default"
    }
  }, [_c('md-dialog-title', [_c('div', {
    staticClass: "noteslist-plans-modal-title"
  }, [_vm._v("Notes List plans")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "noteslist-plans-modal-content"
  }, [_c('div', {
    staticClass: "noteslist-plans-status-block"
  }, [_c('div', {
    staticClass: "noteslist-plans-status-summary"
  }, [_c('div', {
    staticClass: "noteslist-plans-status-text"
  }, [_c('span', {
    staticClass: "noteslist-plans-summary-label"
  }, [_vm._v("Current access")]), _vm._v(" "), _c('span', {
    staticClass: "noteslist-plans-active-plan-name"
  }, [_vm._v(_vm._s(_vm.currentActivePlanName))])]), _vm._v(" "), _c('span', {
    staticClass: "noteslist-account-badge",
    class: _vm.hasActiveIntegrationAccess ? 'is-linked' : 'is-disconnected'
  }, [_vm._v("\n                    " + _vm._s(_vm.hasActiveIntegrationAccess ? 'Active' : 'Not active') + "\n                ")])]), _vm._v(" "), (_vm.periodEndLabel) ? _c('p', {
    staticClass: "noteslist-plans-summary-hint"
  }, [_vm._v("\n                Access period ends: " + _vm._s(_vm.periodEndLabel) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.user.active_pay && !_vm.notesListLinked) ? _c('p', {
    staticClass: "noteslist-plans-summary-hint"
  }, [_vm._v("\n                Connect your Notes List account in Account Settings to unlock Cuelist + Notes List plans.\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "noteslist-plans-section"
  }, [_c('h3', {
    staticClass: "noteslist-plans-section-title"
  }, [_vm._v("Cuelist + Notes List (Dual)")]), _vm._v(" "), _c('p', {
    staticClass: "noteslist-plans-section-copy"
  }, [_vm._v("\n                Full Collaborator access, Notes List partner license, and structure sync.\n            ")]), _vm._v(" "), (!_vm.user.active_pay) ? [_c('div', {
    staticClass: "noteslist-plans-actions-row"
  }, [_c('div', {
    staticClass: "noteslist-plans-interval-row"
  }, [(_vm.dualMonthlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'month'
    },
    attrs: {
      "type": "button",
      "disabled": _vm.baseIntervalLock === 'year'
    },
    on: {
      "click": function($event) {
        _vm.dualUpgradeInterval = 'month'
      }
    }
  }, [_vm._v("\n                            Monthly\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.dualYearlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'year'
    },
    attrs: {
      "type": "button",
      "disabled": _vm.baseIntervalLock === 'month'
    },
    on: {
      "click": function($event) {
        _vm.dualUpgradeInterval = 'year'
      }
    }
  }, [_vm._v("\n                            Annual\n                        ")]) : _vm._e()]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary noteslist-plans-action-btn",
    attrs: {
      "disabled": _vm.dualUpgradeWorking || !_vm.dualUpgradeInterval
    },
    on: {
      "click": _vm.upgradeToDualPlan
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dualUpgradeWorking ? 'Working…' : 'Subscribe with Dual') + "\n                    ")])], 1)] : (_vm.canSwitchDualInterval) ? [_c('div', {
    staticClass: "noteslist-plans-actions-row"
  }, [_c('div', {
    staticClass: "noteslist-plans-interval-row"
  }, [(_vm.dualMonthlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'month'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectDualInterval('month')
      }
    }
  }, [_vm._v("\n                            Monthly" + _vm._s(_vm.currentDualInterval === 'month' ? ' (current)' : '') + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.dualYearlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'year'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectDualInterval('year')
      }
    }
  }, [_vm._v("\n                            Annual" + _vm._s(_vm.currentDualInterval === 'year' ? ' (current)' : '') + "\n                        ")]) : _vm._e()]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary noteslist-plans-action-btn",
    attrs: {
      "disabled": _vm.dualUpgradeWorking || _vm.dualPreviewLoading || _vm.dualUpgradeInterval === _vm.currentDualInterval
    },
    on: {
      "click": _vm.confirmOrPreviewDualUpgrade
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dualActionLabel('Switch plan')) + "\n                    ")]), _vm._v(" "), (_vm.awaitingDualConfirm) ? _c('a', {
    staticClass: "noteslist-plans-cancel-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelDualConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        Cancel\n                    ")]) : _vm._e()], 1)] : (_vm.canUpgradeToDual) ? [_c('div', {
    staticClass: "noteslist-plans-actions-row"
  }, [_c('div', {
    staticClass: "noteslist-plans-interval-row"
  }, [(_vm.dualMonthlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'month'
    },
    attrs: {
      "type": "button",
      "disabled": _vm.baseIntervalLock === 'year'
    },
    on: {
      "click": function($event) {
        return _vm.selectDualInterval('month')
      }
    }
  }, [_vm._v("\n                            Monthly\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.dualYearlyPlanId) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualUpgradeInterval === 'year'
    },
    attrs: {
      "type": "button",
      "disabled": _vm.baseIntervalLock === 'month'
    },
    on: {
      "click": function($event) {
        return _vm.selectDualInterval('year')
      }
    }
  }, [_vm._v("\n                            Annual\n                        ")]) : _vm._e()]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary noteslist-plans-action-btn",
    attrs: {
      "disabled": _vm.dualUpgradeWorking || _vm.dualPreviewLoading || !_vm.dualUpgradeInterval
    },
    on: {
      "click": _vm.confirmOrPreviewDualUpgrade
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.dualActionLabel('Upgrade to Dual')) + "\n                    ")]), _vm._v(" "), (_vm.awaitingDualConfirm) ? _c('a', {
    staticClass: "noteslist-plans-cancel-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelDualConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        Cancel\n                    ")]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.dualPreview && _vm.awaitingDualConfirm) ? _c('p', {
    staticClass: "noteslist-plans-preview"
  }, [(_vm.dualPreview.deferred) ? _c('span', [_vm._v(_vm._s(_vm.dualPreview.message))]) : _c('span', [_vm._v("Estimated charge today: $" + _vm._s(_vm.dualPreview.amount_due_display || '0.00'))])]) : _vm._e(), _vm._v(" "), (_vm.dualUpgradeError) ? _c('p', {
    staticClass: "noteslist-plans-error"
  }, [_vm._v(_vm._s(_vm.dualUpgradeError))]) : _vm._e()], 2), _vm._v(" "), (_vm.showDualTeamSection) ? _c('div', {
    staticClass: "noteslist-plans-section"
  }, [_c('h3', {
    staticClass: "noteslist-plans-section-title"
  }, [_vm._v("Cuelist + Notes List — Educational / Institutional")]), _vm._v(" "), _c('p', {
    staticClass: "noteslist-plans-section-copy"
  }, [_vm._v("\n                Team seats on Notes List, bundled with your Cuelist Educational or Institutional plan.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "noteslist-plans-actions-row"
  }, [_c('div', {
    staticClass: "noteslist-plans-interval-row"
  }, [(_vm.canUpgradeToDualEducational) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualTeamTarget === 'dual_educational'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectDualTeamTarget('dual_educational')
      }
    }
  }, [_vm._v("\n                        Educational\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.canUpgradeToDualInstitutional) ? _c('button', {
    staticClass: "noteslist-plans-chip",
    class: {
      active: _vm.dualTeamTarget === 'dual_institution'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.selectDualTeamTarget('dual_institution')
      }
    }
  }, [_vm._v("\n                        Institutional\n                    ")]) : _vm._e()]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary noteslist-plans-action-btn",
    attrs: {
      "disabled": _vm.dualTeamWorking || _vm.dualTeamPreviewLoading || !_vm.dualTeamTarget
    },
    on: {
      "click": _vm.confirmOrPreviewDualTeamUpgrade
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.dualTeamActionLabel('Upgrade')) + "\n                ")]), _vm._v(" "), (_vm.awaitingDualTeamConfirm) ? _c('a', {
    staticClass: "noteslist-plans-cancel-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelDualTeamConfirm.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.dualTeamPreview && _vm.awaitingDualTeamConfirm) ? _c('p', {
    staticClass: "noteslist-plans-preview"
  }, [(_vm.dualTeamPreview.deferred) ? _c('span', [_vm._v(_vm._s(_vm.dualTeamPreview.message))]) : _c('span', [_vm._v("Estimated charge today: $" + _vm._s(_vm.dualTeamPreview.amount_due_display || '0.00'))])]) : _vm._e(), _vm._v(" "), (_vm.dualTeamError) ? _c('p', {
    staticClass: "noteslist-plans-error"
  }, [_vm._v(_vm._s(_vm.dualTeamError))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15384f7f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/noteslist-plans.vue
// module id = 1205
// module chunks = 21